import Vue from "vue";

export default {
  getPayslipReport(_, reportParams) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/reports/general`, reportParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
